const STORAGE_KEY = "alarm_popup_enabled_v1";
const EVENT_NAME = "alarm-popup-preference-change";

export function isAlarmPopupEnabled() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) return true;
    return raw !== "false";
  } catch {
    return true;
  }
}

export function setAlarmPopupEnabled(enabled) {
  const value = enabled !== false;
  try {
    localStorage.setItem(STORAGE_KEY, value ? "true" : "false");
  } catch {}

  try {
    window.dispatchEvent(
      new CustomEvent(EVENT_NAME, {
        detail: { enabled: value },
      })
    );
  } catch {}

  return value;
}

export function subscribeToAlarmPopupPreference(listener) {
  const handler = (event) => {
    if (event?.type === "storage" && event.key && event.key !== STORAGE_KEY) return;
    listener(isAlarmPopupEnabled());
  };

  window.addEventListener(EVENT_NAME, handler);
  window.addEventListener("storage", handler);

  return () => {
    window.removeEventListener(EVENT_NAME, handler);
    window.removeEventListener("storage", handler);
  };
}

